import { Colors, Metrics, Helpers, Box, Heading3, Text } from '@origin-digital/style-guide';
import React from 'react';
import styled from 'styled-components';
import { System, Savings } from '../../CalculatorResult.types';
import AttachMoneyIcon from '../../../../../../components/Icons/AttachMoneyIcon';
import DateRangeIcon from '../../../../../../components/Icons/DateRangeIcon';
import { formatAsCurrency } from '../../../../../../utils/number/numberHelper';

const CostStyles = styled.div`
  display: flex;
  margin-top: ${Metrics.Spacing.M_Y_LG}px;

  .cost,
  .payback {
    flex: 1;
    display: flex;
    align-items: start;

    .details {
      flex: 1;
    }
  }

  .cost {
    padding-right: ${Metrics.Spacing.P_X_SM}px;
  }

  .payback {
    padding-left: ${Metrics.Spacing.P_X_SM}px;
    border-left: 1px solid ${Colors.GREY16};
  }

  .icon-container {
    display: none;
  }

  ${Helpers.media.LG`
    .payback {
      padding-left: ${Metrics.Spacing.P_X_LG}px;
    }
    .cost {
      padding-right: ${Metrics.Spacing.P_X_LG}px;
    }
    .icon-container {
      display: inline;
    }
  `};
`;

export interface CostProps {
  system: System;
  savings: Savings;
}

export const Cost: React.SFC<CostProps> = ({ system, savings }) => (
  <CostStyles>
    <div className="cost">
      <Box className="icon-container" marginRight={4}>
        <AttachMoneyIcon size={48} color="grey80" />
      </Box>
      <div className="details">
        <Text overflow="normal" size="sm">
          Your system will cost
        </Text>
        <Heading3
          data-id="totalCost"
          text={`${formatAsCurrency(system.totalCost, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`}
        />
      </div>
    </div>

    <div className="payback">
      <Box className="icon-container" marginRight={4}>
        <DateRangeIcon size={48} color="grey80" />
      </Box>
      <div className="details">
        <Text overflow="normal" size="sm">
          It
          {"'"}
          ll be paying for itself in
        </Text>
        <Heading3 data-id="payoffTimeYears" text={`${savings.payoffTimeYears} yrs`} />
      </div>
    </div>
  </CostStyles>
);
